export default {
	"newsletter.email.label": "E-Mail",
	"newsletter.email.placeholder": "Ihre E-Mail Adresse",
	"newsletter.group.label": "Für welches Thema möchten Sie sich anmelden?",
	"newsletter.group.placeholder": "Bitte auswählen",
	"newsletter.send": "Absenden",
} as const;
